import Immutable from 'immutable';
import SimCardAlertCondition from "./SimCardAlertCondition";

const SimCardAlertModel = Immutable.Record({
	id: 0,
	name: '',
	trigger: '',
	triggerThreshold: '',
	triggerPeriod: '',
	conditions: [],
	recipients: [],
	enabled: true
});

export const triggers = {
	status: 'simAlertTrigger.statusChanged',
	data: 'simAlertTrigger.dataUsage',
	call: 'simAlertTrigger.callUsage',
	connections: 'simAlertTrigger.connections',
	// sms: 'simAlertTrigger.smsUsage',
	imei: 'simAlertTrigger.imei'
};

export default class SimCardAlert extends SimCardAlertModel {
	
	id: number;
	name: string;
	trigger: string;
	triggerThreshold: string;
	triggerPeriod: string;
	enabled: boolean;
	conditions: SimCardAlertCondition[];
	recipients: any;

	constructor(props) {
		if(!props) props = {};
		props.conditions = (props.conditions || []).map(c => new SimCardAlertCondition(c));
		super(props);
	}
	
	triggerName(t) {
		return t(triggers[this.get('trigger')]);
	}
	
	get canSave() {
		if(this.get('conditions').filter(c => !c.canSave).size) return false;
		if(!this.get('name')) return false;
		if(!this.get('trigger')) return false;
		if(['call', 'sms', 'data'].indexOf(this.get('trigger')) >= 0) {
			if (!this.get('triggerThreshold')) return false;
			if (!this.get('triggerPeriod')) return false;
		}
		if(this.get('trigger') === 'status') {
			return !!this.get('triggerThreshold')?.length;
		}
		return !!this.get('recipients').length;
	}
}
